import React from "react";
import { styled } from "styled-components";
const Container = styled.div `
  padding: 0 1.25rem 1rem;

  > p {
    font-weight: 500;
    margin: 0;
  }
`;
const PriceRadioBoxPriceTag = ({ price }) => (React.createElement(Container, null,
    React.createElement("p", null,
        new Intl.NumberFormat(price.locale, {
            style: "currency",
            currency: price.currency,
        }).format(price.amount),
        " ",
        price.postfix && price.postfix)));
export default PriceRadioBoxPriceTag;
//# sourceMappingURL=PriceRadioBoxPriceTag.js.map